import LabelIcon from '@material-ui/icons/Label';

import NewsTypeList from './NewsTypeList';
import NewsTypeEdit from './NewsTypeEdit';
import NewsTypeCreate from './NewsTypeCreate';

export default {
    list: NewsTypeList,
    edit: NewsTypeEdit,
    create: NewsTypeCreate,
    icon: LabelIcon,
};
